import { useState } from 'react';
import { ScrollRevealWrapper } from '../../../components/feature/ScrollRevealWrapper';

const transformacoes = [
  {
    nome: 'Dra. Carolina Mendes',
    cargo: 'Sócia Fundadora · Venture Capital · São Paulo',
    foto: 'https://public.readdy.ai/ai/img_res/048d191b87ea461305e514c6250739fe.jpg',
    antes: 'Síndrome da impostora. Triplicava o esforço para provar que merecia estar na mesa.',
    depois: 'Presença de liderança real. Voz que move salas inteiras.',
    conquista: 'Fechou R$ 22M em captações em 4 meses após o programa',
    depoimento: 'Gastei anos construindo competência técnica enquanto um padrão mental me sabotava silenciosamente. O método da Bia foi cirúrgico — identificou exatamente o que me bloqueava e entregou as ferramentas certas. Não foi coaching motivacional. Foi reprogramação clínica com resultados empresariais.',
    tempoResultado: '4 meses',
    tecnica: 'Ancoragem + Identidade',
    estrelas: 5,
  },
  {
    nome: 'Marina Torres',
    cargo: 'VP Operations · Multinacional · Rio de Janeiro',
    foto: 'https://readdy.ai/api/search-image?query=elegant%20powerful%20professional%20woman%20VP%20executive%2037%20years%20old%20dark%20minimal%20background%20warm%20gold%20tones%20confident%20authoritative%20presence%20corporate%20luxury%20portrait&width=600&height=750&seq=depoimento-transform-02&orientation=portrait',
    antes: 'Esgotamento total. Alta performance para fora, colapso silencioso por dentro.',
    depois: 'Energia sustentável. Resultados sem sacrifício.',
    conquista: 'Promovida a VP global. Reduziu a jornada em 35%.',
    depoimento: 'I had tried everything — executive coaching, therapy, meditation apps. O que faltava era alguém que entendesse a estrutura neurológica dos meus padrões. A Bia entrega PNL clínica de nível internacional, não um conjunto de técnicas motivacionais. Em 8 semanas a diferença era visível para toda a equipe.',
    tempoResultado: '8 semanas',
    tecnica: 'Swish + Ressignificação',
    estrelas: 5,
  },
  {
    nome: 'Juliana Ávila',
    cargo: 'CEO & Fundadora · HealthTech B2B · Belo Horizonte',
    foto: 'https://readdy.ai/api/search-image?query=successful%20confident%20Brazilian%20woman%20CEO%20founder%20tech%20startup%2034%20years%20dark%20background%20minimal%20elegant%20corporate%20premium%20portrait%20warm%20lighting%20sophisticated%20look&width=600&height=750&seq=depoimento-transform-03&orientation=portrait',
    antes: 'Tecnicamente preparada. Mentalmente paralisada para crescer.',
    depois: 'Clareza de visão + execução sem bloqueios.',
    conquista: 'Faturamento 4x em 14 meses. Série A captada.',
    depoimento: 'Minha empresa tinha todos os indicadores para crescer. O gargalo era eu — especificamente os padrões mentais que rodavam no background da minha mente. O diagnóstico da Bia foi preciso. As técnicas foram poderosas. O resultado foi mensurável. É o tipo de investimento que multiplica todos os outros.',
    tempoResultado: '14 meses',
    tecnica: 'Modelagem + Linha do Tempo',
    estrelas: 5,
  },
  {
    nome: 'Renata Figueiredo',
    cargo: 'Diretora de Estratégia · Consultoria Global · São Paulo',
    foto: 'https://readdy.ai/api/search-image?query=sophisticated%20professional%20woman%20strategy%20director%20consultant%2042%20years%20dark%20elegant%20background%20confident%20poised%20executive%20presence%20warm%20cinematic%20light%20premium%20portrait%20photography&width=600&height=750&seq=depoimento-transform-04&orientation=portrait',
    antes: 'Perfeccionismo paralisante. Decisões adiadas. Equipe frustrada.',
    depois: 'Clareza decisória. Liderança por valor real.',
    conquista: 'Melhor avaliação de performance em 10 anos de carreira',
    depoimento: 'Levei tempo para entender que meu maior bloqueio não era falta de informação — era um padrão mental de controle disfarçado de excelência. A Bia tem a rara capacidade de nomear o invisível e entregar ferramentas concretas para reprogramar o que nos paralisa. Resultado: clareza, velocidade e paz dentro do mesmo desempenho.',
    tempoResultado: '3 meses',
    tecnica: 'Submodalidades + Ancoragem',
    estrelas: 5,
  },
];

const metricasGerais = [
  { valor: '89%', label: 'Melhora mensurável em 30 dias', icon: 'ri-line-chart-line' },
  { valor: '4.2x', label: 'ROI médio em 90 dias', icon: 'ri-trophy-line' },
  { valor: '12+', label: 'Países alcançados', icon: 'ri-global-line' },
  { valor: '10k+', label: 'Profissionais transformadas', icon: 'ri-group-line' },
];

export default function DepoimentosTransformacao() {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <section className="py-28 bg-[#060606] relative overflow-hidden">
      {/* Gradientes decorativos */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#D4AF37]/20 to-transparent"></div>
        <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#D4AF37]/10 to-transparent"></div>
        <div className="absolute top-1/4 right-0 w-96 h-96 bg-[#D4AF37]/3 rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/4 left-0 w-80 h-80 bg-[#D4AF37]/2 rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        {/* Header */}
        <ScrollRevealWrapper animation="fade-up">
          <div className="max-w-3xl mb-20">
            <div className="inline-flex items-center gap-3 mb-6">
              <div className="h-px w-8 bg-[#D4AF37]/50"></div>
              <span className="text-[#D4AF37] text-xs font-semibold tracking-[0.3em] uppercase font-['Montserrat']">
                Resultados Comprovados
              </span>
            </div>
            <h2 className="font-['Playfair_Display'] text-5xl md:text-6xl font-bold text-white leading-[1.05] mb-5">
              Histórias que mudam<br />
              <span className="text-[#D4AF37] italic">a trajetória.</span>
            </h2>
            <p className="text-white/50 text-lg font-light leading-relaxed font-['Montserrat']">
              Executivas e fundadoras que decidiram resolver o bloqueio interno — e o impacto que isso gerou em suas carreiras e empresas.
            </p>
          </div>
        </ScrollRevealWrapper>

        {/* Métricas gerais */}
        <ScrollRevealWrapper animation="fade-up" delay={0.1}>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-20">
            {metricasGerais.map((m) => (
              <div key={m.label} className="bg-white/[0.04] border border-[#D4AF37]/10 rounded-xl p-5 text-center">
                <div className="w-9 h-9 flex items-center justify-center mx-auto mb-3">
                  <i className={`${m.icon} text-xl text-[#D4AF37]`}></i>
                </div>
                <div className="font-['Playfair_Display'] text-3xl font-bold text-[#D4AF37] mb-1">{m.valor}</div>
                <div className="text-white/35 text-xs font-['Montserrat'] leading-tight">{m.label}</div>
              </div>
            ))}
          </div>
        </ScrollRevealWrapper>

        {/* Depoimento em destaque */}
        <ScrollRevealWrapper animation="fade-up" delay={0.15}>
          <div className="mb-8">
            <div className="grid md:grid-cols-5 gap-0 bg-white/[0.03] border border-[#D4AF37]/15 rounded-2xl overflow-hidden">
              {/* Foto */}
              <div className="md:col-span-2 relative h-[420px] md:h-auto overflow-hidden">
                <img
                  src={transformacoes[activeIndex].foto}
                  alt={transformacoes[activeIndex].nome}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-transparent to-[#0d0d0d]/40 md:block hidden"></div>
                <div className="absolute inset-0 bg-gradient-to-t from-[#0d0d0d]/70 to-transparent md:hidden"></div>

                {/* Badge técnica */}
                <div className="absolute top-5 left-5">
                  <div className="px-3 py-1.5 bg-[#0a0a0a]/80 border border-[#D4AF37]/30 rounded-full backdrop-blur-sm">
                    <span className="text-[#D4AF37] text-xs font-semibold font-['Montserrat']">
                      {transformacoes[activeIndex].tecnica}
                    </span>
                  </div>
                </div>
              </div>

              {/* Conteúdo */}
              <div className="md:col-span-3 p-8 md:p-10 flex flex-col justify-center">
                {/* Estrelas */}
                <div className="flex gap-1 mb-6">
                  {[...Array(transformacoes[activeIndex].estrelas)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-[#D4AF37] text-base"></i>
                  ))}
                </div>

                {/* Quote */}
                <blockquote className="text-white/70 text-lg leading-relaxed italic mb-8 font-['Montserrat'] font-light border-l-2 border-[#D4AF37]/30 pl-6">
                  &ldquo;{transformacoes[activeIndex].depoimento}&rdquo;
                </blockquote>

                {/* Antes e depois */}
                <div className="grid grid-cols-2 gap-3 mb-7">
                  <div className="bg-white/[0.04] rounded-lg p-4 border border-white/5">
                    <p className="text-white/30 text-xs uppercase tracking-wider mb-2 font-['Montserrat']">Antes</p>
                    <p className="text-white/60 text-sm leading-snug font-['Montserrat'] font-light">{transformacoes[activeIndex].antes}</p>
                  </div>
                  <div className="bg-[#D4AF37]/8 rounded-lg p-4 border border-[#D4AF37]/15">
                    <p className="text-[#D4AF37] text-xs uppercase tracking-wider mb-2 font-['Montserrat']">Depois</p>
                    <p className="text-white/75 text-sm leading-snug font-['Montserrat'] font-light">{transformacoes[activeIndex].depois}</p>
                  </div>
                </div>

                {/* Conquista */}
                <div className="flex items-center gap-3 mb-7 p-4 bg-[#D4AF37]/10 rounded-xl border border-[#D4AF37]/20">
                  <i className="ri-award-fill text-[#D4AF37] text-xl flex-shrink-0"></i>
                  <div>
                    <p className="text-white/30 text-xs font-['Montserrat'] uppercase tracking-wider mb-0.5">Resultado em {transformacoes[activeIndex].tempoResultado}</p>
                    <p className="text-white text-sm font-semibold font-['Montserrat']">{transformacoes[activeIndex].conquista}</p>
                  </div>
                </div>

                {/* Identidade */}
                <div className="flex items-center gap-4 pt-5 border-t border-white/[0.06]">
                  <div>
                    <p className="text-white font-semibold font-['Montserrat']">{transformacoes[activeIndex].nome}</p>
                    <p className="text-[#D4AF37]/70 text-sm font-['Montserrat']">{transformacoes[activeIndex].cargo}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ScrollRevealWrapper>

        {/* Seletor de pessoas */}
        <ScrollRevealWrapper animation="fade-up" delay={0.2}>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-16">
            {transformacoes.map((t, i) => (
              <button
                key={i}
                onClick={() => setActiveIndex(i)}
                className={`relative rounded-xl overflow-hidden cursor-pointer transition-all duration-300 ${
                  activeIndex === i ? 'ring-2 ring-[#D4AF37]' : 'hover:ring-1 hover:ring-[#D4AF37]/40 opacity-60 hover:opacity-100'
                }`}
              >
                <div className="aspect-[3/4] relative">
                  <img src={t.foto} alt={t.nome} className="w-full h-full object-cover object-top" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a]/90 via-[#0a0a0a]/20 to-transparent"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-3">
                    <p className="text-white text-xs font-bold font-['Montserrat'] leading-tight">{t.nome.split(' ')[0]} {t.nome.split(' ')[1]}</p>
                    <p className="text-[#D4AF37]/80 text-xs font-['Montserrat'] leading-tight">{t.cargo.split(' · ')[0]}</p>
                  </div>
                </div>
              </button>
            ))}
          </div>
        </ScrollRevealWrapper>

        {/* CTA */}
        <ScrollRevealWrapper animation="fade-up" delay={0.3}>
          <div className="text-center bg-gradient-to-r from-[#0f0c00] to-[#0a0800] border border-[#D4AF37]/20 rounded-2xl p-12">
            <p className="text-[#D4AF37] text-xs tracking-[0.3em] uppercase font-['Montserrat'] mb-4">A próxima história pode ser a sua</p>
            <h3 className="font-['Playfair_Display'] text-3xl md:text-4xl font-bold text-white mb-5">
              Qual padrão mental está<br />limitando o seu próximo nível?
            </h3>
            <p className="text-white/40 text-sm mb-8 font-['Montserrat'] font-light max-w-xl mx-auto">
              Faça o diagnóstico gratuito em 5 minutos e receba a técnica de PNL exata para o seu perfil.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href="/diagnostico"
                className="inline-flex items-center gap-3 px-10 py-4 bg-[#D4AF37] text-black font-bold rounded-lg hover:bg-[#C5A028] transition-all whitespace-nowrap font-['Montserrat'] text-sm tracking-wider uppercase"
              >
                <i className="ri-brain-line text-lg"></i>
                Fazer Diagnóstico Gratuito
                <i className="ri-arrow-right-line text-lg"></i>
              </a>
              <a
                href="/planos"
                className="inline-flex items-center gap-3 px-10 py-4 border border-[#D4AF37]/30 text-[#D4AF37] font-semibold rounded-lg hover:bg-[#D4AF37]/10 transition-all whitespace-nowrap font-['Montserrat'] text-sm"
              >
                Ver Planos
              </a>
            </div>
            <div className="mt-6 flex items-center justify-center gap-2 text-white/25 text-xs font-['Montserrat']">
              <i className="ri-shield-check-fill text-[#D4AF37]/40"></i>
              Diagnóstico 100% gratuito · Resultado imediato
            </div>
          </div>
        </ScrollRevealWrapper>
      </div>
    </section>
  );
}
